<template>
  <ToggleSwitch v-model="isComplete" class="justify-content-center" />
</template>

<script setup>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import ToggleSwitch from "@/components/ToggleSwitch.vue";

const store = useStore();
const props = defineProps({
  itemId: {
    type: Number,
    default: null
  },
  completed: {
    type: Boolean,
    default: false
  }
});
const isComplete = ref(props.completed);

watch(isComplete, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    handleChange();
  }
});

function handleChange() {
  const action = isComplete.value ? "completeWorkItem" : "resetWorkItem";
  store.dispatch(action, props.itemId).then(() => {
    EventBus.$emit("refresh-datatable");
  });
}
</script>

<style lang="scss" scoped></style>
